import { FormItemType } from '../enums';

export function isFormItemType(value: string): value is FormItemType {
	return Object.values<string>(FormItemType).includes(value);
}
